import { createContext, useContext } from 'react';
import type { Variant } from '../types';

interface AlertContextType {
    variant: Variant;
    setDismissed: (value: boolean) => void;
}

export const AlertContext = createContext<AlertContextType>({} as AlertContextType);

export const useAlertContext = () => {
    const context = useContext(AlertContext);
    if (context === undefined) {
        throw new Error('useAlertContext must be used within a AlertContextProvider');
    }
    return context;
};
